import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManufactureRoutingModule } from './manufacture-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ManufactureRoutingModule
  ]
})
export class ManufactureModule { }
